var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("div", { staticClass: "d-flex", attrs: { id: "wrapper" } }, [
        _c("div", { attrs: { id: "page-content-wrapper" } }, [
          _c(
            "nav",
            {
              staticClass:
                "navbar navbar-expand-lg navbar-light bg-na-principal border-bottom fixed-top custom-navbar",
              class: { "mobile-responsive": _vm.isMobile }
            },
            [
              _vm.isMobile
                ? _c("hamburger", { staticClass: "pl-4" })
                : _vm._e(),
              !_vm.isMobile
                ? _c(
                    "div",
                    {
                      staticClass: "sidebar-menu-button",
                      class: { active: _vm.isNavOpened }
                    },
                    [
                      _c("hamburger", {
                        attrs: { color: "bg-white", "show-title": true }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _c("div", { staticClass: "sidebar-heading" }, [
                _c("img", {
                  attrs: {
                    alt: "logo",
                    height: "63px",
                    src: _vm.logoImgUrl,
                    width: "190px"
                  }
                })
              ]),
              _c(
                "div",
                {
                  staticClass: "collapse navbar-collapse show float-right left",
                  attrs: { id: "navbarSupportedContent" }
                },
                [
                  _c(
                    "ul",
                    {
                      staticClass:
                        "navbar-nav mr-auto mt-2 mt-lg-0 d-flex align-items-center"
                    },
                    [
                      _c(
                        "li",
                        [
                          _c(
                            "droppable",
                            {
                              staticClass: "action-item-search",
                              attrs: { show: true },
                              on: { click: _vm.onOpenSearchStudentHandler },
                              scopedSlots: _vm._u([
                                {
                                  key: "drop",
                                  fn: function() {
                                    return [
                                      _c("student-search", {
                                        ref: "studentSearchRef",
                                        attrs: {
                                          "can-select-student": false,
                                          "can-view-history": false,
                                          "get-advanced-search":
                                            _vm.getAdvancedSearch,
                                          "get-impediments": _vm.getImpediments,
                                          "get-student-by-sie":
                                            _vm.getStudentBySie,
                                          "is-mobile": _vm.isMobile
                                        },
                                        on: {
                                          "on-view-student":
                                            _vm.onViewStudentHandler
                                        }
                                      })
                                    ]
                                  },
                                  proxy: true
                                }
                              ])
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "media align-items-center" },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "avatar avatar-sm bg-gray-7 border-none rounded-circle"
                                    },
                                    [
                                      _c("em", {
                                        staticClass: "fas fa-search font-20"
                                      })
                                    ]
                                  )
                                ]
                              )
                            ]
                          ),
                          false
                            ? _c(
                                "droppable",
                                {
                                  staticClass: "action-item-help",
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "drop",
                                        fn: function() {
                                          return [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "deticket-box dropdown-list dropdown-menu dropdown-menu-custom custom-right show mt-4"
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "cursor-pointer",
                                                    on: {
                                                      click:
                                                        _vm.onNavigateToCreateTicket
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "dropdown-item nav-list-item"
                                                      },
                                                      [
                                                        _c("em", {
                                                          staticClass:
                                                            "fas fa-file-plus font-20 color-green mr-2"
                                                        }),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "color-black font-16 font-weight-normal ml-2 pl-1"
                                                          },
                                                          [
                                                            _vm._v(
                                                              " Crear Solicitud "
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                ),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "cursor-pointer",
                                                    on: {
                                                      click:
                                                        _vm.onNavigateToViewTickets
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "dropdown-item nav-list-item"
                                                      },
                                                      [
                                                        _c("em", {
                                                          staticClass:
                                                            "fas fa-file-search font-20 color-green mr-2"
                                                        }),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "color-black font-16 font-weight-normal ml-1"
                                                          },
                                                          [
                                                            _vm._v(
                                                              " Ver Solicitudes "
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          ]
                                        },
                                        proxy: true
                                      }
                                    ],
                                    null,
                                    false,
                                    1474658029
                                  )
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "media align-items-center" },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "avatar avatar-sm rounded-circle deticket"
                                        },
                                        [
                                          _c("em", {
                                            staticClass:
                                              "fal fa-user-headset color-white"
                                          })
                                        ]
                                      )
                                    ]
                                  )
                                ]
                              )
                            : _vm._e(),
                          _c(
                            "droppable",
                            { staticClass: "action-item-notification" },
                            [
                              _c(
                                "div",
                                { staticClass: "media align-items-center" },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "avatar avatar-sm rounded-circle"
                                    },
                                    [
                                      _c("em", {
                                        staticClass: "fas fa-bell color-green"
                                      })
                                    ]
                                  )
                                ]
                              )
                            ]
                          ),
                          false
                            ? _c(
                                "droppable",
                                {
                                  staticClass: "action-item-help",
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "drop",
                                        fn: function() {
                                          return [
                                            _c("card", {
                                              staticClass:
                                                "position-relative nav-card top-60 w-card",
                                              attrs: {
                                                "row-elements":
                                                  _vm.helpCard.rowElements
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "section-bottom",
                                                    fn: function() {
                                                      return [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass: "row"
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "col-12 mb-2"
                                                              },
                                                              [
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "font-15"
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      " Mesa de Apoyo "
                                                                    )
                                                                  ]
                                                                )
                                                              ]
                                                            ),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "col-12"
                                                              },
                                                              [
                                                                _c("Link", {
                                                                  attrs: {
                                                                    color:
                                                                      "gray-6",
                                                                    "color-icon":
                                                                      "gray-7",
                                                                    icon:
                                                                      "fas fa-phone-alt",
                                                                    text:
                                                                      _vm
                                                                        .contactInfo
                                                                        .phone,
                                                                    "with-border": false
                                                                  }
                                                                })
                                                              ],
                                                              1
                                                            ),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "col-12"
                                                              },
                                                              [
                                                                _c("Link", {
                                                                  attrs: {
                                                                    color:
                                                                      "gray-6",
                                                                    "color-icon":
                                                                      "gray-7",
                                                                    icon:
                                                                      "fas fa-envelope",
                                                                    text:
                                                                      _vm
                                                                        .contactInfo
                                                                        .mail,
                                                                    "with-border": false
                                                                  }
                                                                })
                                                              ],
                                                              1
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    },
                                                    proxy: true
                                                  }
                                                ],
                                                null,
                                                false,
                                                3220850949
                                              )
                                            })
                                          ]
                                        },
                                        proxy: true
                                      }
                                    ],
                                    null,
                                    false,
                                    1870974803
                                  )
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "media align-items-center" },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "avatar avatar-sm rounded-circle"
                                        },
                                        [
                                          _c("em", {
                                            staticClass:
                                              "fal fa-question-circle color-green"
                                          })
                                        ]
                                      )
                                    ]
                                  )
                                ]
                              )
                            : _vm._e()
                        ],
                        1
                      ),
                      _vm.userHasPermissions("provider.help.view")
                        ? _c("li", { staticClass: "mr-2" }, [
                            _c(
                              "div",
                              { staticClass: "dropdown dropdown-help" },
                              [
                                _vm._m(0),
                                _c(
                                  "div",
                                  {
                                    staticClass: "dropdown-menu mt-1",
                                    attrs: { "aria-labelledby": "btnhelp" }
                                  },
                                  [
                                    _vm.userHasPermissions(
                                      "provider.help.createticket.view"
                                    )
                                      ? _c(
                                          "a",
                                          {
                                            staticClass:
                                              "dropdown-item d-flex align-items-center cursor-pointer",
                                            on: {
                                              click:
                                                _vm.handleOpenCloseTicketFlow
                                            }
                                          },
                                          [
                                            _c("img", {
                                              staticClass: "mr-2 ml-n2",
                                              attrs: {
                                                alt: "circle-plus",
                                                src: require("@/assets/img/circle-plus-green.svg")
                                              }
                                            }),
                                            _vm._v(" Crear un Ticket ")
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm.userHasPermissions(
                                      "provider.chatbotbtn"
                                    )
                                      ? _c(
                                          "a",
                                          {
                                            staticClass:
                                              "dropdown-item d-flex align-items-center cursor-pointer",
                                            on: {
                                              click:
                                                _vm.handleOpenCloseVirtualAssistant
                                            }
                                          },
                                          [
                                            _c("img", {
                                              staticClass: "mr-2 ml-n2",
                                              attrs: {
                                                alt: "sparkles",
                                                src: require("@/assets/img/sparkles.svg")
                                              }
                                            }),
                                            _vm._v(" Asistente Virtual ")
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm.userHasPermissions(
                                      "provider.help.mytickets.view"
                                    )
                                      ? _c(
                                          "a",
                                          {
                                            staticClass:
                                              "dropdown-item d-flex align-items-center cursor-pointer",
                                            on: {
                                              click:
                                                _vm.handleNavigateToMyTickets
                                            }
                                          },
                                          [
                                            _c("img", {
                                              staticClass: "mr-2 ml-n2",
                                              attrs: {
                                                alt: "ticket",
                                                src: require("@/assets/img/ticket.svg")
                                              }
                                            }),
                                            _vm._v(" Mis Tickets ")
                                          ]
                                        )
                                      : _vm._e()
                                  ]
                                )
                              ]
                            )
                          ])
                        : _vm._e(),
                      _c(
                        "li",
                        [
                          _c("custom-user-info", {
                            staticClass: "ml-3 custom-user-info",
                            attrs: {
                              "last-login-date": new Date(
                                _vm.userInfo.lastlogindate
                              ),
                              "row-actions": _vm.userCard.rowActions,
                              "row-elements": _vm.userCard.rowElements
                            }
                          })
                        ],
                        1
                      )
                    ]
                  )
                ]
              )
            ],
            1
          )
        ])
      ]),
      _c("modal-password", {
        attrs: { show: _vm.displayChangeUserPassword },
        on: { "on-close": _vm.onClosing, submit: _vm.changePassword }
      }),
      _c("student-search-info", {
        attrs: {
          "academic-years": _vm.academicYears,
          "enrollment-school-data": _vm.enrollmentSchoolData,
          "pei-history-data": _vm.peiHistoryData,
          show: _vm.showStudentInfo,
          "show-therapy-tab": false,
          "status-list": _vm.studentStatuses,
          "student-info": _vm.studentInfo,
          therapies: []
        },
        on: {
          loadenrollmentSchoolData: _vm.loadenrollmentSchoolData,
          "on-close": _vm.onCloseHandler,
          "on-search-pei-history": _vm.onSearchPeiHistoryHandler
        }
      }),
      _vm.profileModalVisible
        ? _c("my-profile", {
            attrs: {
              "save-profile": _vm.updateMyProfile,
              "user-info": { ..._vm.userInfo, roleId: _vm.userInfo.roleid }
            },
            model: {
              value: _vm.profileModalVisible,
              callback: function($$v) {
                _vm.profileModalVisible = $$v
              },
              expression: "profileModalVisible"
            }
          })
        : _vm._e(),
      _vm.updateProfileVisible
        ? _c("profile-info", {
            attrs: {
              "save-profile": _vm.updateMyProfile,
              user: _vm.userInfo,
              value: ""
            },
            on: { close: _vm.updateProfileVisibleHandler }
          })
        : _vm._e(),
      _c("ticket-flow", {
        attrs: { email: _vm.userInfo.email },
        on: { close: _vm.handleOpenCloseTicketFlow }
      }),
      _c("virtual-assistant", {
        attrs: { "user-full-name": _vm.userFullName },
        on: { close: _vm.handleOpenCloseVirtualAssistant }
      })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "button",
      {
        staticClass:
          "btn btn-secondary dropdown-toggle d-flex align-items-center dropdown-toggle-help",
        attrs: {
          id: "btnhelp",
          "aria-expanded": "false",
          "aria-haspopup": "true",
          "data-toggle": "dropdown",
          type: "button"
        }
      },
      [
        _c("img", {
          staticClass: "mr-2",
          attrs: {
            alt: "circle-question",
            src: require("@/assets/img/circle-question.svg")
          }
        }),
        _vm._v(" Ayuda ")
      ]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }